import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "flex min-h-full items-center justify-center" }
const _hoisted_2 = { class: "grid h-[calc(100vh-3rem)] w-full max-w-5xl gap-6 overflow-hidden rounded-[2rem] border border-white/15 bg-white p-4 shadow-[0_30px_80px_rgba(15,23,42,0.35)] lg:grid-cols-[minmax(0,1.5fr)_320px] lg:p-6" }
const _hoisted_3 = { class: "min-h-[320px] overflow-hidden rounded-[1.5rem] bg-slate-100 h-full" }
const _hoisted_4 = {
  key: 0,
  class: "flex h-full w-full items-center justify-center text-sm font-medium text-slate-500"
}
const _hoisted_5 = { class: "flex h-full flex-col overflow-hidden rounded-[1.5rem] bg-slate-50" }
const _hoisted_6 = { class: "flex-1 overflow-y-auto p-4" }
const _hoisted_7 = { class: "flex flex-col gap-4" }
const _hoisted_8 = { class: "mt-2 line-clamp-2 text-lg font-semibold text-slate-900" }
const _hoisted_9 = {
  key: 0,
  class: "mt-3 text-xs leading-5 text-rose-600"
}
const _hoisted_10 = {
  key: 1,
  class: "mt-3 text-xs leading-5 text-slate-500"
}
const _hoisted_11 = {
  key: 0,
  class: "overflow-hidden rounded-full bg-slate-200"
}
const _hoisted_12 = { class: "bg-slate-50 p-4 pt-0" }
const _hoisted_13 = { class: "flex flex-col gap-3 sm:flex-row lg:flex-col" }
const _hoisted_14 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueCropper = _resolveComponent("VueCropper")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.open)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 z-[100] overflow-y-auto bg-slate-950/70 px-4 py-6 backdrop-blur-sm",
          onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_ctx.sourceLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Loading image... "))
                  : (_ctx.resolvedCropperSrc)
                    ? (_openBlock(), _createBlock(_component_VueCropper, {
                        key: 1,
                        ref: "cropper",
                        class: "cropper-panel h-full w-full",
                        title: _ctx.result.title,
                        src: _ctx.resolvedCropperSrc,
                        rotatable: false,
                        scalable: false,
                        zoomable: false,
                        viewMode: 1,
                        aspectRatio: 1,
                        autoCropArea: 1,
                        minCropBoxWidth: 200,
                        minCropBoxHeight: 200,
                        checkCrossOrigin: true,
                        preview: '.crop-preview',
                        onReady: _ctx.ready
                      }, null, 8, ["title", "src", "onReady"]))
                    : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", null, [
                      _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-xs font-semibold uppercase tracking-[0.3em] text-slate-500" }, "Crop Selection", -1)),
                      _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.result.title), 1),
                      _cache[4] || (_cache[4] = _createElementVNode("p", { class: "mt-2 text-sm leading-6 text-slate-600" }, "Adjust the square crop, review the preview, then apply it to the selected grid cell.", -1))
                    ]),
                    _createElementVNode("div", null, [
                      _cache[5] || (_cache[5] = _createElementVNode("p", { class: "mb-3 text-sm font-medium text-slate-700" }, "Preview", -1)),
                      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "crop-preview mx-auto aspect-square w-full max-w-[240px] overflow-hidden rounded-[1.5rem] border border-slate-200 bg-white shadow-inner" }, null, -1)),
                      (_ctx.errorMessage)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.errorMessage), 1))
                        : (_openBlock(), _createElementBlock("p", _hoisted_10, "This preview updates live as you move the crop box."))
                    ]),
                    (_ctx.processing)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[7] || (_cache[7] = [
                          _createElementVNode("div", { class: "h-2 w-full animate-pulse bg-gradient-to-r from-blue-400 via-sky-500 to-cyan-400" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-medium text-slate-700 hover:border-slate-300 hover:bg-slate-100",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                    }, " Cancel "),
                    _createElementVNode("button", {
                      type: "button",
                      class: "w-full rounded-2xl bg-slate-900 px-4 py-3 text-sm font-medium text-white hover:bg-slate-700 disabled:cursor-not-allowed disabled:bg-slate-300",
                      disabled: _ctx.processing || _ctx.sourceLoading || !_ctx.resolvedCropperSrc,
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.applyCrop && _ctx.applyCrop(...args)))
                    }, _toDisplayString(_ctx.processing ? "Cropping..." : _ctx.sourceLoading ? "Loading..." : "Crop Image"), 9, _hoisted_14)
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}